import type { ReactNode } from 'react';
import styles from './FilterField.module.css';

export interface FilterFieldProps {
  /**
   * Etiqueta que se muestra ARRIBA del control (mayúsculas, gris).
   * Ej: "CORREO", "TIPO DE OPERACIÓN".
   */
  label: string;
  /**
   * id del control para asociar la etiqueta (accesibilidad).
   */
  htmlFor?: string;
  /**
   * El control (Input, Filter, DateRangePicker, etc.).
   */
  children: ReactNode;
  className?: string;
}

export function FilterField({ label, htmlFor, children, className }: FilterFieldProps) {
  const classes = [styles.field, className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <label className={styles.label} htmlFor={htmlFor}>
        {label}
      </label>
      {children}
    </div>
  );
}

FilterField.displayName = 'FilterField';
